import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Invoice } from '@kinet-open-network/client/invoices/data-access';
import { downloadBlob } from '@kinet-open-network/client/shared/util';
import { plainToInstance } from 'class-transformer';
import { map } from 'rxjs';
import { InvoiceStatus } from '../models/invoice-status.model';

@Injectable({
  providedIn: 'root',
})
export class ZoneInvoicesService {
  private http = inject(HttpClient);

  getInvoiceStatus() {
    return this.http
      .get<InvoiceStatus>(`/invoices/status`)
      .pipe(map((invoices) => plainToInstance(InvoiceStatus, invoices)));
  }

  getLatestInvoices() {
    return this.http
      .get<Invoice[]>(`/invoices`)
      .pipe(map((invoices) => plainToInstance(Invoice, invoices)));
  }

  downloadInvoice(invoice: Invoice) {
    return this.http
      .get(`/invoices/${invoice.id}/download`, {
        responseType: 'blob',
      })
      .pipe(
        map((blob) => downloadBlob(blob, `faktura_${invoice.internalId}.pdf`)),
      );
  }
}
